var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPill = function SvgPill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 4.64a8.72 8.72 0 0 0-8.34 3.87L9.87 30.77a9.45 9.45 0 0 0 2.64 13.08 9.42 9.42 0 0 0 13.07-2.63l14.54-21.86A9.52 9.52 0 0 0 33 4.64M23.67 40a7.15 7.15 0 0 1-9.89 2 7.14 7.14 0 0 1-2-9.89l6.47-9.73a.29.29 0 0 1 .41-.08l11.38 7.57a.29.29 0 0 1 .09.41zm14.82-22.34-5.81 8.73a2 2 0 0 1-2.77.56l-8.55-5.69a2 2 0 0 1-.56-2.77l5.53-8.31C29.25 5.8 36.21 5.69 39 11.49a6.29 6.29 0 0 1-.51 6.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.59 13.43-1.41-.94a.31.31 0 0 1-.08-.43 6.37 6.37 0 0 1 8.38-1.69.31.31 0 0 1 .1.43l-.95 1.42a.29.29 0 0 1-.39.09 4.05 4.05 0 0 0-5.24 1 .3.3 0 0 1-.41.12"
  })));
};
export default SvgPill;